import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import '../../styles/reserva-salas.css'


function ReservaSalas() {
  const [salas, setSalas] = useState([]);
  const [form, setForm] = useState({
    fecha: '',
    duracion: 'todo_dia',
    hora_inicio: '',
    hora_fin: '',
    actividad: '',
    sala: '', // Esto será un string porque los valores del select son strings
  });
  const [salaImagen, setSalaImagen] = useState('https://placehold.co/300x200');

  useEffect(() => {
    api.get(`salas/`, { withCredentials: true })
      .then(response => {
        setSalas(response.data);
        if (response.data.length > 0) {
          const firstSalaId = response.data[0].id.toString(); // Convierte a string
          setForm(prev => ({ ...prev, sala: firstSalaId }));
          setSalaImagen(response.data[0].imagen);
        }
      })
      .catch(error => console.error('Error fetching salas:', error));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => {
      const newForm = { ...prev, [name]: value };
      if (name === 'sala') {
        const sala = salas.find(s => s.id.toString() === value); // Convierte s.id a string para comparar
        setSalaImagen(sala ? sala.imagen : 'https://placehold.co/300x200');
      } else if (name === 'duracion' && value !== 'horario') {
        newForm.hora_inicio = '';
        newForm.hora_fin = '';
      }
      return newForm;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const today = new Date().toISOString().split('T')[0];
    const now = new Date().toTimeString().slice(0, 5);

    if (form.fecha < today) {
      alert('No puedes reservar fechas pasadas.');
      return;
    }

    if (form.fecha === today) {
      if (form.duracion === 'todo_dia' && now >= '15:00') {
        alert('No puedes reservar "Todo el día" para hoy después de las 15:00.');
        return;
      } else if (form.duracion === 'manana' && now >= '15:00') {
        alert('No puedes reservar "Mañana" para hoy después de las 15:00.');
        return;
      } else if (form.duracion === 'tarde' && now >= '23:59') {
        alert('No puedes reservar "Tarde" para hoy después de las 23:59.');
        return;
      } else if (form.duracion === 'horario' && form.hora_fin <= now) {
        alert('No puedes reservar un horario que ya ha pasado.');
        return;
      }
    }
    try {
      const csrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('csrftoken='))
        ?.split('=')[1];

      const formData = { ...form };
      formData.sala_id = parseInt(form.sala, 10); // Convierte a número para enviar al backend
      if (form.duracion !== 'horario') {
        delete formData.hora_inicio;
        delete formData.hora_fin;
      } else {
        formData.hora_inicio = form.hora_inicio || null;
        formData.hora_fin = form.hora_fin || null;
      }

      await api.post(`reservas/`, formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
      });

      alert('Reserva creada con éxito');
    } catch (error) {
      // Extraer el mensaje de error
      let errorMessage = 'Error al crear la reserva'; // Mensaje por defecto
      if (error.response?.data) {
        if (error.response.data.non_field_errors && Array.isArray(error.response.data.non_field_errors)) {
          // Si hay non_field_errors, tomar el primer mensaje
          errorMessage = error.response.data.non_field_errors[0];
        } else if (error.response.data.detail) {
          // Si hay un campo detail, usarlo
          errorMessage = error.response.data.detail;
        }
      } else if (error.message) {
        // Si no hay response.data, usar error.message
        errorMessage = error.message;
      }
    
      // Mostrar el error en la consola
      console.error('Error creating reserva:', errorMessage);
    
      // Mostrar el error en un alert
      alert(errorMessage);
    }
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let hour = 8; hour < 22; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        options.push(time);
      }
    }
    return options;
  };

  return (
    <div className="page">
      <h1>Reserva de salas</h1>
      <p>Esta sección es solo para socios.</p>
      <div className="reserva-container">
        <div className="reserva-form">
          <form onSubmit={handleSubmit}>
            <div>
              <label>Sala:</label>
              <select name="sala" value={form.sala} onChange={handleChange} required>
                {salas.map(sala => (
                  <option key={sala.id} value={sala.id.toString()}>
                    {sala.nombre}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label>Fecha:</label>
              <input
                type="date"
                name="fecha"
                value={form.fecha}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Duración:</label>
              <select name="duracion" value={form.duracion} onChange={handleChange} required>
                <option value="todo_dia">Todo el día</option>
                <option value="manana">Mañana</option>
                <option value="tarde">Tarde</option>
                <option value="horario">Horario</option>
              </select>
            </div>
            {form.duracion === 'horario' && (
              <>
                <div>
                  <label>Hora de inicio:</label>
                  <select
                    name="hora_inicio"
                    value={form.hora_inicio}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecciona una hora</option>
                    {generateTimeOptions().map((time) => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>Hora de fin:</label>
                  <select
                    name="hora_fin"
                    value={form.hora_fin}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecciona una hora</option>
                    {generateTimeOptions().map((time) => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}
            <div>
              <label>Actividad:</label>
              <input
                type="text"
                name="actividad"
                value={form.actividad}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit">Reservar</button>
          </form>
        </div>
        <div className="sala-imagen">
          <img src={salaImagen} alt="Sala seleccionada" />
        </div>
      </div>
    </div>
  );
}

export default ReservaSalas;